import React from 'react'

import { useTranslation } from 'react-i18next'

import { Button } from '@/Atomic/Molecules/Button'

interface SearchResultsCardFooterProps {
  showAllResults: () => void
}

export const SearchResultsCardFooter: React.FC<
  SearchResultsCardFooterProps
> = ({ showAllResults }) => {
  const { t } = useTranslation()

  return (
    <div className="card-footer">
      <Button
        variant="outlined"
        size="sm"
        title={t('search.showAllResults')}
        className="w-100 m-0"
        onClick={showAllResults}
      />
    </div>
  )
}
